<template>
    <b-container>
        <div v-if="gelen.hataVarMi">
            {{gelen.mesaj }}
        </div>
        <!-- User Interface controls -->
        <div v-else>
            <b-row>
                <b-col lg="6" sm="12">
                    <b-form-group
                            label="Arama"
                            label-cols-sm="2"
                            label-align-sm="left"
                            label-size="md"
                            label-for="searchInput"
                            label-class="font-weight-bold"
                            class="mb-0"
                    >
                        <b-form-input
                                v-model="searchText"
                                type="search"
                                id="searchInput"
                                placeholder="Arama"
                        />
                    </b-form-group>
                </b-col>
                <b-col lg="4" sm="12">
                    <b-button style="width: 40%" variant="info" @click="searchClick('sahsi')">{{belgeTuru}}larımda
                    </b-button>
                    <b-button style="width: 52%" class="ml-1" variant="success" @click="searchClick('hepsi')">Tüm
                        {{belgeTuru}}larda
                    </b-button>
                </b-col>
            </b-row>

            <hr>
            <b-row>
                <b-col lg="6" md="12">
                    <b-form-group
                            label="Durum"
                            label-cols-sm="2"
                            label-align-sm="left"
                            label-size="md"
                            label-for="initialSortSelect"
                            label-class="font-weight-bold"
                    >
                        <b-form-select
                                v-model="durumSelection"
                                id="initialSortSelect"
                                size="md"
                                value-field="item"
                                text-field="name"
                                :options="
                                           [{ item: '', name: intToDurumString(-1) },
                                           { item: '0', name: intToDurumString(0) },
                                           { item: '1', name: intToDurumString(1) },
                                           { item: '2', name: intToDurumString(2) },
                                           { item: '3', name: intToDurumString(3) },
                                           { item: '4', name: intToDurumString(4) }]"
                                @change="durumSelectionChange"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <h5>
                        <b-badge>Toplam kayıt: {{toplamKayit}}</b-badge>
                    </h5>
                </b-col>
            </b-row>
            <!-- Main table element -->
            <b-table
                    show-empty
                    small
                    striped
                    hover
                    stacked="md"
                    empty-text="Kayıt Bulunamadı"
                    select-mode="single"
                    :selectable="true"
                    :no-local-sorting="true"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="0"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="sortingChanged"
                    @row-selected="rowSelected"
            >

                <template v-slot:cell(aciklama)="data">
                    <span v-html="data.value"></span>
                </template>
            </b-table>

            <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
            />

            <!-- Info modal -->
            <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
                <pre>{{ infoModal.content }}</pre>
            </b-modal>
        </div>
    </b-container>
</template>

<script>
    import {belgelerGetir} from "@/api/belgeler";
    import moment from "moment";
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {mapGetters} from "vuex";
    import {utilsMixin} from "@/utils/utilsMixin";

    export default {
        mixins: [utilsMixin],
        data() {
            return {
                items: [],
                fields: [
                    {key: 'belgeId', label: 'ID', sortable: true},
                    {key: 'durum', label: 'Durum', sortable: true},
                    {key: 'editor', label: 'Editör', sortable: true},
                    {key: 'editorIslem', label: 'Editör İslem', sortable: true},
                    {key: 'operator', label: 'Operatör', sortable: true},
                    {key: 'operatorIslem', label: 'Operator İşlem', sortable: true},
                    {
                        key: 'guncellemeTarihi',
                        label: 'Güncellenme Tarihi',
                        sortable: true,
                        sortByFormatted: value => {
                            return moment(value, 'DD-MM-YYYY').toDate()
                        },
                        formatter: value => {
                            return moment(value).format('DD-MM-YYYY')
                        }
                    },
                    {key: 'aciklama', label: 'Açıklama', sortable: false},
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 500,
                sortBy: 'guncellemeTarihi',
                sortDesc: true,
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },
                gelen: {
                    hataVarMi: true,
                    mesaj: "Yükleniyor"
                },
                durumSelection: '',
                searchField: '',
                searchText: '',
                belgeTuru: 'Mektup'
            }
        },
        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'girisYapmismi'
            ]),
            toplamKayit() {
                return new Intl.NumberFormat('tr', {currency: 'try'}).format(this.totalRows)
            },

        },
        watch: {
            '$route.query'() {

                this.bismillah()
            },
            currentPage: {
                handler: function (value) {
                    this.bismillah()
                }
            }
        },
        async mounted() {
            this.bismillah();
        },
        methods: {
            async bismillah() {
                const that = this;
                if (!this.girisYapmismi) {
                    await new GoogleTokenIleGirisYapmayiDene(this);
                }

                if (!this.girisYapmismi) {
                    this.gelen.mesaj = "Giriş yapmanız lazım";
                    this.gelen.hataVarMi = true;

                    setTimeout(function () {
                        that.$router.push("/giris-yap?url=" + encodeURI("/mektup"))
                    }, 3000);
                    return

                }

                this.gelen = await belgelerGetir(this.$route.query.tur || "kart", this.$route.query.ne || "hepsi", this.$route.query.aranan, this.currentPage, this.perPage, this.sortBy, this.sortDesc, this.durumSelection, this.$route.query.id);


                if (this.gelen.hataVarMi) {

                    if (this.gelen.kod === "giris-yap") {
                        const that = this;
                        setTimeout(function () {
                            that.$router.push("/giris-yap?url=" + encodeURI(that.gelen.data))
                        }, 1000);
                        return
                    }

                    return;
                }
                this.items = this.gelen.data;
                this.totalRows = this.gelen.totalRows;
                that.$store.commit('setArama', {metin: this.searchText, filitre: this.durumSelection});

                if (this.$route.query.aranan) {
                    this.fields.find(x => x.key === 'aciklama').label = "Önizleme";
                    this.searchText = this.$route.query.aranan
                } else {
                    this.fields.find(x => x.key === 'aciklama').label = "Açıklama"
                }

                if (this.$route.query.tur === 'kart') {
                    this.belgeTuru = 'Kart'
                } else {
                    this.belgeTuru = 'Mektup'
                }
            },

            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetInfoModal() {
                this.infoModal.title = ''
                this.infoModal.content = ''
            },
            sortingChanged(ctx) {
                this.sortBy = ctx.sortBy;
                this.sortDesc = ctx.sortDesc;
                this.bismillah()
            },
            durumSelectionChange(event) {
                this.bismillah()
            },
            searchClick(ne) {
                if (this.searchText && this.searchText.length > 2) {
                    this.currentPage = 1;
                    const urlParams = new URLSearchParams(window.location.search);
                    urlParams.set('aranan', this.searchText);
                    urlParams.set('ne', ne);

                    this.$router.push("/belgeler?" + urlParams.toString());

                } else {
                    this.$notify({
                        group: 'ust',
                        title: 'Uyarı',
                        text: 'Lütfen 2 karakterden fazla giriniz!',
                        type: 'warn'
                    });
                }
            },
            rowSelected(items) {
                if (this.$route.query.tur === "mektup")
                    this.$router.push('/mektup?id=' + items[0].belgeId)
                else
                    this.$router.push('/kart?id=' + items[0].belgeId)

            }
        }
    }
</script>